import { defineStore } from 'pinia';
import { ref } from 'vue';

export type ToastKind = 'info' | 'success' | 'warn' | 'error';

export interface Toast {
    id: number;
    kind: ToastKind;
    title: string;
    message?: string;
}

let nextId = 1;

export const useToastStore = defineStore('toast', () => {
    const items = ref<Toast[]>([]);

    function push(kind: ToastKind, title: string, message?: string, ttlMs = 4500) {
        const id = nextId++;
        items.value.push({ id, kind, title, message });
        if (ttlMs > 0) {
            setTimeout(() => dismiss(id), ttlMs);
        }
    }

    function dismiss(id: number) {
        items.value = items.value.filter((t) => t.id !== id);
    }

    return {
        items,
        push,
        dismiss,
        info: (title: string, message?: string) => push('info', title, message),
        success: (title: string, message?: string) => push('success', title, message),
        warn: (title: string, message?: string) => push('warn', title, message),
        error: (title: string, message?: string) => push('error', title, message, 7000)
    };
});